import * as React from 'react';
import { IconProps } from '../types';

const IcMenuKeyIn = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
     <g clipPath="url(#a)">
      <path
        fill={props?.fill ?? '#232F3E'}
        d="M20.76 22H4.24a1.739 1.739 0 0 1-1.74-1.74V3.74A1.74 1.74 0 0 1 4.24 2h16.52a1.739 1.739 0 0 1 1.74 1.74v16.52A1.739 1.739 0 0 1 20.76 22ZM12.066 2.87H4.24a.87.87 0 0 0-.87.87v7.825h8.696V2.87Zm0 9.565H3.37v7.826a.87.87 0 0 0 .87.87h7.825v-8.696Zm9.565-8.696a.87.87 0 0 0-.87-.87h-7.825v8.696h8.695V3.74Zm0 8.696h-8.695v8.695h7.826a.87.87 0 0 0 .87-.87v-7.825Zm-2.174 6.087H15.11a.435.435 0 1 1 0-.87h4.347a.435.435 0 0 1 0 .87Zm0-2.609H15.11a.435.435 0 1 1 0-.87h4.347a.435.435 0 0 1 0 .87Zm-4.347-9.13h4.347a.435.435 0 0 1 0 .87H15.11a.435.435 0 1 1 0-.87Zm-9.44 7.943a.435.435 0 0 1 .615 0l1.415 1.413 1.365-1.365a.436.436 0 0 1 .615.617l-1.366 1.365 1.353 1.353a.435.435 0 1 1-.615.613L7.699 17.37l-1.402 1.4a.43.43 0 0 1-.709-.141.432.432 0 0 1 .095-.473l1.4-1.4L5.67 15.34a.431.431 0 0 1 0-.613Zm-.126-7.943h1.74v-1.74a.435.435 0 0 1 .87 0v1.74H9.89a.435.435 0 1 1 0 .87H8.152V9.39a.435.435 0 1 1-.87 0V7.652H5.544a.435.435 0 1 1 0-.87Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M2.5 2h20v20h-20z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcMenuKeyIn;
